export class Choice {
    ID: boolean;
    Name: string;

    constructor(id: boolean, name: string) {
        this.ID = id;
        this.Name = name;
    }
}
